"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _propTypes = _interopRequireDefault(require("prop-types"));

var ExportButton = function ExportButton(_ref) {
  var exportUrl = _ref.exportUrl;

  var goGetExport = function goGetExport() {
    window.open(exportUrl);
  };

  return exportUrl ? /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: goGetExport,
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: "smp--data-grid-navbar-view--export-button",
    dataElementId: "smp--data-grid-navbar-view--export-button"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "cloud_download"
  })) : /*#__PURE__*/_react["default"].createElement("div", null);
};

ExportButton.propTypes = {
  exportUrl: _propTypes["default"].string
};
var _default = ExportButton;
exports["default"] = _default;